export default "__VITE_ASSET__5b2be479__"